module.exports = __webpack_public_path__ + "media/images/river/home-page-header-camden-2590f2094e4dcc37094e2500c2a9a038.jpg";